import { buildPoaXslt, encodeBase64 } from './documents';

const ORG_ID = '11111111-1111-1111-1111-111111111111';
const ADMIN_ID = '22222222-2222-2222-2222-222222222222';
const STAFF_ID = '33333333-3333-3333-3333-333333333333';
const PARTNER_ORG_ID = '44444444-4444-4444-4444-444444444444';
const INVITE_ID = '55555555-5555-5555-5555-555555555555';
const STAFF_INVITE_ID = '66666666-6666-6666-6666-666666666666';
const DOC_ID = '77777777-7777-7777-7777-777777777777';
const POA_ID = '88888888-8888-8888-8888-888888888888';
const NEW_DOC_ID = '99999999-0000-0000-0000-000000000001';
const NDA_DOC_ID = 'aaaaaaaa-0000-0000-0000-000000000001';
const INCOMING_INVITE_ID = 'bbbbbbbb-0000-0000-0000-000000000001';
const STATUS_DRAFT = '22b6be53-ac81-4371-a1ed-5a0066ec4846';
const STATUS_SIGNED = '6a905bb4-8c62-4b7a-bcd3-55a8c761fa2d';
const STATUS_APPROVED = 'e622b09f-9905-465d-8053-733fa24c6953';
const STATUS_REJECTED = '08e2f259-9ae2-4103-ad8f-01f0567bb7ce';
const STATUS_CANCELLED = '4cba08ff-cd3f-4403-a570-123faca0be28';

function jwt(extra: Record<string, unknown> = {}) {
  const header = btoa(JSON.stringify({ alg: 'none', typ: 'JWT' }));
  const payload = btoa(
    JSON.stringify({
      exp: Math.floor(Date.now() / 1000) + 86400,
      identity_id: ADMIN_ID,
      identity_type: 2,
      org_id: ORG_ID,
      extra: { x_auth_provider_name: 'password' },
      ...extra,
    }),
  );
  return `${header}.${payload}.mock`;
}

export const IDS = {
  ORG_ID,
  ADMIN_ID,
  STAFF_ID,
  PARTNER_ORG_ID,
  INVITE_ID,
  STAFF_INVITE_ID,
  DOC_ID,
  NEW_DOC_ID,
  NDA_DOC_ID,
  INCOMING_INVITE_ID,
  POA_ID,
  STATUS_DRAFT,
  STATUS_SIGNED,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_CANCELLED,
};

export const TOKENS = {
  admin: {
    access_token: jwt({ identity_id: ADMIN_ID, login: 'admin@mock.local' }),
    refresh_token: jwt({ typ: 'refresh' }),
    token_type: 'bearer',
  },
  staff: {
    access_token: jwt({ identity_id: STAFF_ID, login: 'staff@mock.local' }),
    refresh_token: jwt({ typ: 'refresh' }),
    token_type: 'bearer',
  },
  limited: {
    access_token: jwt({ identity_id: '99999999-9999-9999-9999-999999999999', org_id: '' }),
    refresh_token: jwt({ typ: 'refresh' }),
    token_type: 'bearer',
  },
};

export const KNOWN_USERS: Record<string, keyof typeof TOKENS> = {
  'admin@mock.local': 'admin',
  'staff@mock.local': 'staff',
  'limited@mock.local': 'limited',
  'f02_dev_ui_590219788@example.com': 'admin',
};

export const PASSWORD = 'Seven123456';
export const PIN = '123456';

export const organization = {
  id: ORG_ID,
  name: 'Нефтесервисная компания',
  status: 1,
  type: 1,
  countryCode: 'ru',
  createdAt: '2026-01-01T00:00:00Z',
  updatedAt: '2026-01-01T00:00:00Z',
  attributes: [
    { name: 'inn', value: '7707083893' },
    { name: 'kpp', value: '770701001' },
    { name: 'ogrn', value: '1027700132195' },
    { name: 'email', value: 'org@mock.local' },
    { name: 'phone', value: '+79990000000' },
    { name: 'country', value: 'RUS' },
    { name: 'address', value: 'г. Москва, ул. Тверская, 1' },
    { name: 'postal_country', value: 'RUS' },
    { name: 'postal_address', value: 'г. Москва, ул. Тверская, 1' },
  ],
};

export const partnerOrganization = {
  ...organization,
  id: PARTNER_ORG_ID,
  name: 'Оператор месторождения',
  attributes: [{ name: 'inn', value: '5020052888' }],
};

export const adminEmployee = {
  id: ADMIN_ID,
  firstName: 'Иван',
  middleName: 'Иванович',
  lastName: 'Петров',
  status: 'active',
  snils: '12345678901',
  inn: '123456789012',
  role: 'administrator',
  email: 'admin@mock.local',
  createdAt: '2026-01-01T00:00:00Z',
  updatedAt: '2026-01-01T00:00:00Z',
  attributes: [
    { name: 'email', value: 'admin@mock.local' },
    { name: 'inn', value: '123456789012' },
    { name: 'snils', value: '12345678901' },
    { name: 'country', value: 'ru' },
    { name: 'phone', value: '+79990000000' },
  ],
  organization_context: [
    {
      organizationID: ORG_ID,
      employeeID: ADMIN_ID,
      role: 'administrator',
      type: 'general',
      position: 'Директор',
      status: 'active',
      powers: [],
    },
  ],
};

export const staffEmployee = {
  ...adminEmployee,
  id: STAFF_ID,
  firstName: 'Алексей',
  lastName: 'Сидоров',
  role: 'employee',
  email: 'staff@mock.local',
  attributes: [{ name: 'email', value: 'staff@mock.local' }],
  organization_context: [
    {
      organizationID: ORG_ID,
      employeeID: STAFF_ID,
      role: 'employee',
      type: 'general',
      position: 'Менеджер',
      status: 'active',
      powers: [],
    },
  ],
};

export const documentStatuses = [
  { id: STATUS_DRAFT, alias: 'draft', appId: { id: 'app-1' } },
  { id: STATUS_SIGNED, alias: 'signed', appId: { id: 'app-1' } },
  { id: STATUS_APPROVED, alias: 'approved', appId: { id: 'app-1' } },
  { id: STATUS_REJECTED, alias: 'rejected', appId: { id: 'app-1' } },
  { id: STATUS_CANCELLED, alias: 'cancelled', appId: { id: 'app-1' } },
];

export const contract = {
  id: DOC_ID,
  title: 'Договор поставки топлива',
  number: 'Д-1001',
  typeId: 'supply',
  docDate: '2026-08-01',
  version: 1,
  statusId: STATUS_SIGNED,
  createdAt: '2026-08-01T00:00:00Z',
  updatedAt: '2026-08-01T00:00:00Z',
  validFrom: '2026-08-01',
  validTo: '2027-08-01',
  tbs: 'tbs-mock',
  tbd: [],
  contractors: [{ id: PARTNER_ORG_ID, name: partnerOrganization.name }],
  template: { id: 'tpl-supply' },
  orgOwner: {
    id: ORG_ID,
    name: organization.name,
    status: '1',
    type: '1',
    countryCode: 'ru',
    createdAt: organization.createdAt,
    updatedAt: organization.updatedAt,
  },
};

/** Contract just created from the form: still a draft, so its preview offers signing. */
export const draftContract = {
  ...contract,
  id: NEW_DOC_ID,
  number: 'Д-2002',
  statusId: STATUS_DRAFT,
  version: 0,
};

/**
 * Типы договоров приложения Активы (KCONT-2110 / 2148). Шаблоны отдаёт бэк,
 * фронт их не хардкодит — в моке перечислены, чтобы в мастере договора было
 * из чего выбирать. Шестой тип в выгрузке тикета пустой, поэтому его здесь нет.
 */
const KTMA_APPLICATION = {
  id: 'c236b64c-7e9f-4735-a897-5c7586ce2594',
  traits: [],
  alias: 'assets',
};

const KTMA_AGREEMENT_TITLES = [
  'Агентский договор (ЕТЗ)',
  'Субагентский договор',
  'Договор закупки',
  'Договор стройконтроля',
  'Договор логистического сопровождения',
  'Договор монтажа',
  'Договор выполнения работ',
  'Договор оказания услуг поверки',
];

const ktmaAgreementTemplates = KTMA_AGREEMENT_TITLES.map((title, index) => ({
  id: `998c51f8-4dd8-450e-b7ff-b0aeafb97f${String(index).padStart(2, '0')}`,
  typeId: 'agreement',
  alias: `ktma-agreement-${index + 1}`,
  applicationID: KTMA_APPLICATION.id,
  title,
  description: 'КТМ-А',
  path: null,
  api: '/applications/api/assets',
  createdAt: '2026-01-01T00:00:00Z',
  updatedAt: '2026-01-01T00:00:00Z',
  application: KTMA_APPLICATION,
}));

export const KTMA_PASSPORT_TEMPLATE = {
  id: 'b7e2c1a0-4dd8-450e-b7ff-b0aeafb97fac',
  typeId: 'passport',
  alias: 'ktma-passport',
  applicationID: KTMA_APPLICATION.id,
  title: { ru: 'Цифровой паспорт', en: 'Digital passport' },
  isCreatable: true,
  completeStatus: 'SIGNED',
  scenario: 'ktma-passport',
};

export const templates = [
  {
    id: 'tpl-supply',
    typeId: 'supply',
    applicationID: null,
    title: 'Поставка нефтепродуктов',
    description: 'Mock template',
    path: null,
    api: '/applications/api/np-supply',
    createdAt: '2026-01-01T00:00:00Z',
    updatedAt: '2026-01-01T00:00:00Z',
  },
  ...ktmaAgreementTemplates,
];

function mockCert(commonName: string, thumbprint: string) {
  return {
    id: `cert-${thumbprint.slice(0, 6)}`,
    thumbprint,
    pure_pem:
      '-----BEGIN CERTIFICATE-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA\n-----END CERTIFICATE-----',
    attributes: {
      common_name: commonName,
      country: 'RU',
      given_name: 'Иван Иванович',
      inn_legal_entity: '7707083893',
      locality: 'Москва',
      ogrn: '1027700132195',
      organization: commonName,
      position: 'Директор',
      province: 'Москва',
      serial_number: '123456',
      snils: '12345678901',
      street_address: 'Тверская 1',
      surname: 'Петров',
    },
  };
}

export const registeredBundle = {
  Certificates: {
    'Нефтесервисная компания': mockCert(
      'Нефтесервисная компания',
      'AABBCCDDEEFF00112233445566778899AABBCCDD',
    ),
    'Оператор месторождения': mockCert(
      'Оператор месторождения',
      'BBCCDDEEFF00112233445566778899AABBCCDDEE',
    ),
  },
};

export const unregisteredBundle = {
  Certificates: {
    'Новая компания': mockCert(
      'Новая компания',
      'CCDDEEFF00112233445566778899AABBCCDDEEFF',
    ),
  },
};

const poaUser = (name: string, surname: string, organizationName: string) => ({
  id: STAFF_ID,
  userType: 'employee',
  rawUserInfo: JSON.stringify({
    name,
    surname,
    organization_name: organizationName,
  }),
});

export const poaDraft = {
  id: POA_ID,
  number: 'МЧД-1001',
  issueDate: '2026-08-01',
  status: 'active',
  updatedAt: '2026-08-01T00:00:00Z',
  createdAt: '2026-08-01T00:00:00Z',
  expirationDate: '2027-08-01',
  revocationDate: null,
  representative: poaUser('Алексей', 'Сидоров', 'Нефтесервисная компания'),
  authority: poaUser('Иван', 'Петров', 'Нефтесервисная компания'),
  recipientOrganization: {
    id: PARTNER_ORG_ID,
    name: 'Оператор месторождения',
    status: 1,
    type: 1,
    countryCode: 'ru',
    createdAt: '2026-01-01T00:00:00Z',
    updatedAt: '2026-01-01T00:00:00Z',
  },
  powerDomain: [
    {
      code: 'sign',
      textDescription: 'Подпись документов',
      content: '',
    },
  ],
  // XML of the POA itself — this is what the preview renders and what gets signed.
  content: encodeBase64(
    buildPoaXslt({
      number: 'МЧД-1001',
      issueDate: '01.08.2026',
      expirationDate: '01.08.2027',
      principal: 'Нефтесервисная компания, Петров Иван Иванович',
      representative: 'Сидоров Алексей Иванович',
      powers: ['Подписание документов', 'Представление интересов организации'],
    }),
  ),
};

export const poaListItem = {
  poaDraft,
  authority: poaDraft.authority,
  representative: poaDraft.representative,
};

/**
 * HTML-превью договора присоединения (поле `tbd_data` ответа `/register/signup/pki/start`).
 * Бэкенд отдаёт его в base64 — мок повторяет форму, иначе экран оферты остаётся пустым.
 */
export const accessionAgreementHtml =
  '<h2>Договор присоединения</h2>' +
  '<p>ООО «Новая компания» присоединяется к условиям платформы Контрактиум.</p>' +
  '<p>Дата: 01.08.2026</p>';

export const accessionAgreementBase64 = btoa(unescape(encodeURIComponent(accessionAgreementHtml)));

export function listItem(id: string, extra: Record<string, unknown> = {}) {
  return {
    id,
    number: 1,
    statusId: STATUS_DRAFT,
    orgOwnerId: ORG_ID,
    agreementName: 'Доп. соглашение №1',
    requestDate: '2026-08-01',
    ...extra,
  };
}

/**
 * Топливные документы в схеме вложенные: задача содержит операционную заявку,
 * контрольная карта — задачу. Моки повторяют форму ответа, иначе экраны
 * рендерят пустые строки, а регрессия остаётся незамеченной.
 */
export function operationalRequest(id = 'request-1') {
  return listItem(id, {
    version: 1,
    shippingDate: '2026-08-10',
    deliveryBasis: 'FCA',
    supplyAddress: 'Москва',
    goodsType: 'ДТ',
    quantity: 10,
    employeeOwner: ADMIN_ID,
    employeeReceiving: STAFF_ID,
    comment: 'Комментарий к заявке',
    createdAt: '2026-08-01',
    updatedAt: '2026-08-01',
  });
}

export function shipmentTask(id = 'task-1') {
  return {
    id,
    version: 1,
    statusId: STATUS_DRAFT,
    operationalRequest: operationalRequest(`${id}-request`),
    supplierExecutor: 'Поставщик Пётр',
    buyerExecutor: 'Покупатель Павел',
    createdAt: '2026-08-01',
    updatedAt: '2026-08-01',
  };
}

export function controlCard(id = 'card-1') {
  return {
    id,
    version: 1,
    statusId: STATUS_DRAFT,
    shipmentTask: shipmentTask(`${id}-task`),
    actualShipmentDate: '2026-08-12',
    actualQuantity: 9,
    createdAt: '2026-08-01',
    updatedAt: '2026-08-01',
  };
}

export function shipmentReport(id = 'report-1') {
  return {
    id,
    number: 1,
    document: 'Д-1001',
    agreement: 'ДС-1',
    period: '2026-08',
    quantity: 10,
    statusId: STATUS_DRAFT,
    orgSupplier: ORG_ID,
    orgBuyer: PARTNER_ORG_ID,
    data: [
      { number: 1, agreement: 'ДС-1', period: '2026-08', quantity: 10, statusId: STATUS_DRAFT },
    ],
  };
}

export function shipmentRegistry(id = 'registry-1') {
  return {
    id,
    version: 1,
    statusId: STATUS_DRAFT,
    number: '1',
    period: '2026-08',
    buyerInn: '7700000000',
    buyerKpp: '770001001',
    buyer: 'ООО «Покупатель»',
    document: 'Д-1001',
    agreement: 'ДС-1',
    total: 1000,
    invoiceNumber: 'СФ-1',
    invoiceDate: '2026-08-15',
    invoiceTotal: '1000',
    createdAt: '2026-08-01',
    updatedAt: '2026-08-01',
  };
}

/** Response of `GET {widget api}/list` — schema of the widget table plus its rows. */
export function widgetList() {
  return {
    title: 'Заявки',
    filters: [
      {
        type: 'select',
        field: { label: 'Статус', value: 'status' },
        options: [
          { label: 'Черновик', value: 'draft' },
          { label: 'Подписан', value: 'signed' },
        ],
      },
    ],
    headers: [{ number: 'Номер' }, { agreement: 'Соглашение' }, { status: 'Статус' }],
    // По одной строке на каждое действие из `clickOperation`: просмотр, правка и подпись.
    // Так двусторонний флоу проверяется без второго аккаунта.
    records: [
      {
        id: 'widget-row-1',
        orgOwnerId: ORG_ID,
        clickOperation: 'get',
        data: { number: '1', agreement: 'ДС-1', status: 'Подписан' },
      },
      {
        id: 'widget-row-2',
        orgOwnerId: ORG_ID,
        clickOperation: 'update',
        data: { number: '2', agreement: 'ДС-2', status: 'Черновик' },
      },
      {
        id: 'widget-row-3',
        orgOwnerId: PARTNER_ORG_ID,
        clickOperation: 'sign',
        data: { number: '3', agreement: 'ДС-3', status: 'На согласовании' },
      },
    ],
    options: { isCreatable: true, isTerminable: true },
    meta: { limit: 10, page: 1, total: 3 },
  };
}

/**
 * Flat form scheme used by fuel-supply documents (`utils/scheme-parser/flat`):
 * a field list where every field carries its own step.
 */
const OPERATIONAL_AGREEMENT_ID = 'agreement-1';
const OPERATIONAL_AGREEMENT_LABEL =
  'Договор №РД-2085-probe от 2026-08-01, Доп. соглашение №1';

/** Схема формы заявки как в probe F16: 14 полей, `deliveryBasis` — dependentSelect. */
export const operationalRequestTemplate = [
  {
    name: 'DraftingPlace',
    type: 'input',
    fieldType: 'input',
    required: false,
    disabled: true,
    isVisible: true,
    label: { ru: 'Место заключения договора', en: 'Place' },
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'StartingDate',
    type: 'datepicker',
    fieldType: 'datepicker',
    required: false,
    label: { ru: 'Дата начала', en: 'Start date' },
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'DocumentValidityPeriod',
    type: 'datepicker',
    fieldType: 'datepicker',
    required: false,
    label: { ru: 'Период валидности документа', en: 'Validity' },
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'agreement',
    type: 'select',
    fieldType: 'select',
    required: true,
    label: { ru: 'Соглашение', en: 'Agreement' },
    step: 1,
    stepLabel: 'Параметры заявки',
    options: [{ label: OPERATIONAL_AGREEMENT_LABEL, value: OPERATIONAL_AGREEMENT_ID }],
  },
  {
    name: 'cession',
    type: 'select',
    fieldType: 'select',
    required: false,
    label: { ru: 'Цессия', en: 'Cession' },
    step: 1,
    stepLabel: 'Параметры заявки',
    options: [],
  },
  {
    name: 'agreementName',
    type: 'generable',
    fieldType: 'generable',
    required: false,
    isVisible: false,
    label: { ru: '', en: '' },
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'requestDate',
    type: 'datepicker',
    fieldType: 'datepicker',
    required: true,
    label: { ru: 'Дата заявки', en: 'Request date' },
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'shippingDate',
    type: 'datepicker',
    fieldType: 'datepicker',
    required: true,
    label: { ru: 'Дата отгрузки', en: 'Shipping date' },
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'deliveryBasis',
    type: 'dependentSelect',
    fieldType: 'dependentSelect',
    required: true,
    label: { ru: 'Базис поставки', en: 'Delivery basis' },
    step: 1,
    stepLabel: 'Параметры заявки',
    optionsDependency: 'agreement',
    optionsDependentSelect: [
      {
        value: OPERATIONAL_AGREEMENT_ID,
        options: [{ label: 'Самовывоз с НПЗ', value: 'Самовывоз с НПЗ' }],
      },
    ],
  },
  {
    name: 'supplyAddress',
    type: 'input',
    fieldType: 'input',
    required: true,
    label: { ru: 'Адрес доставки', en: 'Supply address' },
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'goodsType',
    type: 'input',
    fieldType: 'input',
    required: true,
    disabled: true,
    label: { ru: 'Продукт', en: 'Product' },
    step: 1,
    stepLabel: 'Параметры заявки',
    value: 'ДТ',
  },
  {
    name: 'quantity',
    type: 'input',
    fieldType: 'input',
    required: true,
    label: { ru: 'Количество, тн.', en: 'Quantity' },
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'isCommentEnabled',
    type: 'checkbox',
    fieldType: 'checkbox',
    required: false,
    label: { ru: 'Добавить комментарий', en: 'Add comment' },
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'comments',
    type: 'input',
    fieldType: 'input',
    required: false,
    label: { ru: 'Комментарии', en: 'Comments' },
    step: 1,
    stepLabel: 'Параметры заявки',
    isVisibleDependency: 'isCommentEnabled',
  },
];

export const fuelTemplate = [
  {
    name: 'agreementId',
    label: 'Соглашение',
    fieldType: 'select',
    type: 'select',
    step: 1,
    stepLabel: 'Параметры заявки',
    options: [{ label: 'ДС-1', value: 'agreement-1' }],
    validation: 'string.required',
  },
  {
    name: 'shippingDate',
    label: 'Дата отгрузки',
    fieldType: 'datepicker',
    type: 'datepicker',
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'goodsType',
    label: 'Тип топлива',
    fieldType: 'input',
    type: 'input',
    step: 1,
    stepLabel: 'Параметры заявки',
  },
  {
    name: 'quantity',
    label: 'Количество, т',
    fieldType: 'input',
    type: 'input',
    step: 1,
    stepLabel: 'Параметры заявки',
  },
];

/**
 * Steps-format scheme used by contracts and widgets (`utils/scheme-parser/steps`):
 * `steps[].elements[]`, where the parser derives the field name from `field` and the
 * control from `type`.
 */
export const contractTemplate = {
  steps: [
    {
      name: 'Основные параметры',
      elements: [
        {
          field: 'contractNumber',
          label: 'Номер договора',
          type: 'input',
          isRequired: true,
          supposedInputType: 'string',
        },
        {
          field: 'conclusionDate',
          label: 'Дата заключения',
          type: 'datepicker',
          isRequired: true,
        },
        {
          field: 'conclusionPlace',
          label: 'Место заключения',
          type: 'input',
          isRequired: true,
          supposedInputType: 'string',
        },
        {
          field: 'subject',
          label: 'Предмет договора',
          type: 'input',
          isRequired: false,
          supposedInputType: 'string',
        },
      ],
      // Footer buttons come from the scheme, not from the page.
      buttons: [{ type: 'submit', label: 'Отправить' }],
    },
  ],
};
